import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './BalanceSplitModal.styles';
import { BalanceItem } from '@/features/Profile/sections/Balance/api';
import { BalanceCard } from '@/features/Profile/sections/Balance/components/BalanceCard';

type BalanceSplitModalProps = {
  isOpen: boolean;
  onClose: () => void;
  items: BalanceItem[];
  onTopUp: () => void;
};

export const BalanceSplitModal = ({
  isOpen,
  onClose,
  items,
  onTopUp,
}: BalanceSplitModalProps) => {
  const { t } = useTranslation();

  return (
    <S.Sheet
      isOpen={isOpen}
      onClose={onClose}
      title={t('pages.cabinet.balance_split')}
      isInPortal
    >
      <S.Cards>
        {items.map((item, index) => (
          <BalanceCard
            key={item.title}
            item={item}
            isTotal={index === items.length - 1}
            isInModal
          />
        ))}
      </S.Cards>
      <S.Actions>
        <S.TopUpButton onClick={onTopUp}>
          {t('pages.cabinet.replenish_account')}
        </S.TopUpButton>
      </S.Actions>
    </S.Sheet>
  );
};
